<template>
  <div class="tva-chapter-component">
    <div
      class="cover-image"
      :style="{backgroundImage: `url(${baseUrl}images/${content.img}${$retina ? '@2x' : ''}${$tvaMq === 'mobile' ? '_m' : ''}.jpg)`}"
    ></div>
    <div class="main-title tva-row">
      <div class="text tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-offset-1 tva-col-md-10">
        <span class="number-text">{{content.number}}</span>
        <span class="chapter-text">{{content.chapter}}</span>
        <h3>{{content.title}}</h3>
      </div>
    </div>

    <div class="download-button" @click="openDownload(true)">
      <img src="@/assets/images/download-button.svg">
    </div>
    <div :class="['download-box', {'open': downloadOpen}]">
      <p class="title">Download</p>
      <div class="close-box" @click="openDownload(false)">
        <svgicon icon="close" width="32" height="32"></svgicon>
      </div>
      <div class="first-block">
        <div class="link" v-for="(link, index) in $ml.get('download').downloads" :key="index">
          <img src="@/assets/images/pdf-icon.svg">
          <div class="text">
            <p>{{link.weight}}</p>
            <a :href="link.url" target="_blank">{{link.name}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/compiled-icons/download-button";
export default {
  props: ["content"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      downloadOpen: false
    };
  },
  methods: {
    openDownload(value) {
      this.downloadOpen = value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
@import "../assets/scss/bootstrap-grid.scss";
.tva-chapter-component {
  position: relative;
  .download-box {
    width: 500px;
    position: fixed;
    z-index: 999;
    bottom: 0px;
    left: -500px;
    background: white;
    padding: 30px;
    transition: all 0.3s ease;
    box-shadow: -1px 0px 12px 1px rgba(0, 0, 0, 0.22);
    &.open {
      left: 0px;
    }
    .title {
      font-weight: 800;
    }
    .close-box {
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
      pointer-events: all;
      .svg-icon {
        fill: $eni-grey;
      }
    }
    .link {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 20px 0;
      img {
        height: 30px;

        padding-right: 20px;
      }
      .text {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
        transition: all 0.5s ease;
        letter-spacing: 0.7px;
        padding-left: 20px;
        border-left: solid 1px $eni-grey;
        &:after {
          content: "";
          width: 0;
          height: 100%;
          background: rgba($eni-yellow, 0.5);
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
          transition: all 0.5s ease;
        }
        &:hover {
          color: $eni-grey;
          &:after {
            width: 100%;
          }
        }
        a {
          font-family: "Avenir Next";
          font-size: 16px;
          font-weight: 800;
          line-height: 19px;
          color: $eni-grey;
          padding-right: 15px;
        }
      }
    }
  }
  .download-button {
    position: fixed;
    bottom: 50px;
    left: 50px;
    z-index: 999;
    cursor: pointer;
    img {
      height: 50px;
      width: 50px;
      border-radius: 50%;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.22);
    }
  }
  .cover-image {
    height: calc(100vh - 88px);
    width: 100vw;
    margin-top: 88px;
    background-size: cover;
    background-position: 10% 10%;
  }
  .main-title {
    background: white;
    padding: 50px 0;
    margin-top: -170px;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    .text {
      .number-text,
      .chapter-text {
        font-family: "Avenir Next";
        font-size: 14px;
        font-weight: 800;
        text-align: center;
        color: $eni-grey;
        text-transform: uppercase;
      }
      .number-text {
        border-right: solid 1px $eni-yellow;
        padding-right: 10px;
        margin-right: 10px;
      }
    }
  }
}
@media (max-width: 1024px) {
  .tva-chapter-component {
    .cover-image {
      height: 50vh;
      width: 100vw;
    }
    .main-title {
      margin-top: 30px;
      padding: 0;
    }
  }
}
@media (max-width: 720px) {
  .tva-chapter-component {
    .cover-image {
      height: 40vh;
      width: 100vw;
      margin-top: 46px;
    }
    .main-title {
      margin-top: 30px;
      padding: 0;
    }
  }
}
</style>

